"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isJestEnv = isJestEnv;
/**
 * Check that we are running in jest for internal development we need to disable this check
 * @private
 * @returns { boolean } returns true when running with jest
 */
function isJestEnv() {
  return typeof process !== 'undefined' && process.env.JEST_WORKER_ID !== undefined && !globalThis.internalDevelopment;
}
